import { IRequestResultDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';
import { isOfType } from 'src/shared/utils/typeGuard';

/**
 * Accepts the error object sent by the backend and returns a localized error string
 * (Assumed that the error messages from the backend are localized)
 */
export const getErrorMessage = (error: IError, fallbackErrorMessage: string): string => {
  if (
    !isOfType<IRequestResultDTO>(error.data, 'validationErrors') &&
    !isOfType<IRequestResultDTO>(error.data, 'errorMessage')
  ) {
    return fallbackErrorMessage;
  }

  const { validationErrors, errorMessage } = error.data;

  // Validation errors and error message should be returned as localized strings from the backend
  const localizedErrorMessage = validationErrors?.length
    ? validationErrors[0]?.message
    : errorMessage ?? fallbackErrorMessage;

  return localizedErrorMessage;
};
